import { ReactNode } from "react";
import { useTabsContext } from "./useTabContext";

// Types
export type TabItemProps = {
  label: string;
  value: number | string;
  icon?: ReactNode;
  badge?: number;
  disabled?: boolean;
  className?: string
  notification?: number | string | boolean; // Nouvelle prop pour la notification
  notificationColor?: string; // Couleur personnalisée pour la notification
  children?: React.ReactNode;
};

// Tab Item Component
export const TabItem: React.FC<TabItemProps> = ({
  label,
  value,
  icon,
  badge,
  disabled,
  className,
  notification,
  notificationColor = "bg-red-500",
  children
}) => {
  const { activeTab, setActiveTab, fullWidth, tiny } = useTabsContext();

  const handleClick = () => {
    if (!disabled) {
      setActiveTab(value);
    }
  };

  const isActive = activeTab === value;
  // Déterminer si on doit afficher la notification
  const shouldShowNotification = notification !== undefined &&
    notification !== false &&
    notification !== 0 &&
    notification !== "";

  return (
    <li
      className={`
        cursor-pointer text-sm relative transition-all duration-300 ease-in-out
        ${fullWidth ? "w-full" : "w-auto"}
        ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        ${tiny ? "px-3 py-2" : "px-4 py-3"}
        ${disabled ? "" : "hover:text-gray-800"}
      `}
      onClick={handleClick}
    >
      <div className="flex items-center gap-2.5">
        {icon}
        <span className={
          className
            ? `${className} ${tiny ? "text-xs" : ""} relative`
            : `${tiny ? "text-xs" : "text-base font-bold text-gray-800"} relative`
        }>
          {label}

          {/* Bulle de notification */}
          {shouldShowNotification && (
            <div className={`
            absolute -top-2 -right-5 min-w-[16px] h-4 rounded-full flex items-center justify-center
            ${notificationColor} text-white text-xs font-bold px-1
            ${tiny ? "text-[10px] min-w-[14px] h-3.5" : ""}
          `}>
              {typeof notification === 'number' && notification > 0 ? (
                notification > 99 ? '99+' : notification
              ) : typeof notification === 'string' ? (
                notification.length > 2 ? notification.substring(0, 2) : notification
              ) : (
                <div className="w-2 h-2 rounded-full bg-white"></div>
              )}
            </div>
          )}
        </span>
        {badge !== undefined && (
          <div className={`
            rounded-full w-6 h-6 flex items-center justify-center
            ${isActive
              ? "bg-primary text-white"
              : "bg-primary/10 text-primary"
            }
          `}>
            <p className="text-sm font-bold">
              {badge}
            </p>
          </div>
        )}
      </div>

      {/* Barre arrondie pour l'onglet actif */}
      {isActive && (
        <div className={`
          absolute bottom-0 left-1/2 transform -translate-x-1/2 h-1 bg-primary rounded-full transition-all duration-300
          ${fullWidth ? "w-full" : "w-auto min-w-full"}
        `}></div>
      )}

      {children}
    </li>
  );
};
